/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Activity } from '../models/Activity';
import type { Athlete } from '../models/Athlete';
import type { AuthResponse } from '../models/AuthResponse';
import type { BackfillRun } from '../models/BackfillRun';
import type { BackfillStart } from '../models/BackfillStart';
import type { Gear } from '../models/Gear';
import type { PaginatedActivities } from '../models/PaginatedActivities';
import type { Segment } from '../models/Segment';
import type { SegmentEffort } from '../models/SegmentEffort';
import type { SplitRequest } from '../models/SplitRequest';
import type { SplitResult } from '../models/SplitResult';
import type { Stream } from '../models/Stream';
import type { Trail } from '../models/Trail';
import type { TrailSearchResult } from '../models/TrailSearchResult';
import type { WebhookAck } from '../models/WebhookAck';
import type { WebhookEvent } from '../models/WebhookEvent';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DefaultService {
    /**
     * Auth Start
     * Redirect the user to Strava's OAuth authorization URL.
     *
     * Args:
     * scope (str): OAuth scopes to request.
     * Returns:
     * RedirectResponse: HTTP redirect to Strava authorization.
     * @param scope Comma-separated OAuth scopes
     * @returns any Successful Response
     * @throws ApiError
     */
    public static authStartStravaAuthStartGet(
        scope: string = 'read,activity:read_all',
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/strava/auth/start',
            query: {
                'scope': scope,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Auth Complete
     * Handle the OAuth callback, exchange code for tokens, create JWT, and store in MongoDB.
     *
     * Args:
     * code (str): Authorization code returned by Strava.
     * Returns:
     * AuthResponseSchema: JWT token and athlete info for API access.
     * Raises:
     * HTTPException: If exchange fails.
     * @param code
     * @returns AuthResponse Successful Response
     * @throws ApiError
     */
    public static authCompleteStravaAuthCompleteGet(
        code: string,
    ): CancelablePromise<AuthResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/strava/auth/complete',
            query: {
                'code': code,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Register Webhook
     * Register a webhook subscription with Strava.
     *
     * Returns:
     * Dict[str, Any]: Subscription details from Strava.
     * Raises:
     * HTTPException: If registration fails.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static registerWebhookStravaWebhookRegisterGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/strava/webhook/register',
        });
    }
    /**
     * Webhook Callback
     * Handle Strava webhook verification challenge.
     *
     * Args:
     * hub_mode (str): Mode of the webhook (should be 'subscribe').
     * hub_challenge (str): Challenge string to echo back.
     * hub_verify_token (str): Verification token to validate.
     * Returns:
     * Dict[str, Any]: Echoed challenge if verified.
     * Raises:
     * HTTPException: If verification fails.
     * @param hubMode
     * @param hubChallenge
     * @param hubVerifyToken
     * @returns any Successful Response
     * @throws ApiError
     */
    public static webhookCallbackStravaWebhookCallbackGet(
        hubMode: string,
        hubChallenge: string,
        hubVerifyToken: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/strava/webhook/callback',
            query: {
                'hub_mode': hubMode,
                'hub_challenge': hubChallenge,
                'hub_verify_token': hubVerifyToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Webhook Event
     * Handle incoming webhook events from Strava.
     *
     * Args:
     * event (Dict[str, Any]): Webhook event payload.
     * Returns:
     * Dict[str, str]: Acknowledgment of receipt.
     * @param requestBody
     * @returns WebhookAck Successful Response
     * @throws ApiError
     */
    public static webhookEventStravaWebhookCallbackPost(
        requestBody: WebhookEvent,
    ): CancelablePromise<WebhookAck> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/strava/webhook/callback',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Strava User
     * Retrieve authenticated athlete profile, using cache unless forced.
     *
     * Requires JWT authentication via Bearer token.
     * @param force Force fetch from Strava API
     * @returns Athlete Successful Response
     * @throws ApiError
     */
    public static getStravaUserStravaAthleteGet(
        force: boolean = false,
    ): CancelablePromise<Athlete> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/strava/athlete',
            query: {
                'force': force,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Strava Activity
     * Retrieve a single activity for the authenticated athlete, using cache unless forced.
     *
     * Requires JWT authentication via Bearer token.
     * @param activityId
     * @param force Force fetch from Strava API
     * @returns Activity Successful Response
     * @throws ApiError
     */
    public static getStravaActivityStravaActivityActivityIdGet(
        activityId: number,
        force: boolean = false,
    ): CancelablePromise<Activity> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/strava/activity/{activity_id}',
            path: {
                'activity_id': activityId,
            },
            query: {
                'force': force,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Strava Gear
     * Return cached gear, including historical gear that Strava marks retired.
     * @param gearId
     * @param force Force fetch from Strava API
     * @returns Gear Successful Response
     * @throws ApiError
     */
    public static getStravaGearStravaGearGearIdGet(
        gearId: string,
        force: boolean = false,
    ): CancelablePromise<Gear> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/strava/gear/{gear_id}',
            path: {
                'gear_id': gearId,
            },
            query: {
                'force': force,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Activity Segment Efforts
     * Return all stored segment efforts for one activity.
     * @param activityId
     * @returns SegmentEffort Successful Response
     * @throws ApiError
     */
    public static getActivitySegmentEffortsStravaActivityActivityIdSegmentEffortsGet(
        activityId: number,
    ): CancelablePromise<Array<SegmentEffort>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/strava/activity/{activity_id}/segment-efforts',
            path: {
                'activity_id': activityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Segment Efforts
     * Return the authenticated athlete's efforts for one segment, newest first.
     * @param segmentId
     * @returns SegmentEffort Successful Response
     * @throws ApiError
     */
    public static getSegmentEffortsStravaSegmentSegmentIdEffortsGet(
        segmentId: number,
    ): CancelablePromise<Array<SegmentEffort>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/strava/segment/{segment_id}/efforts',
            path: {
                'segment_id': segmentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Strava Segment
     * Retrieve stored detailed metadata for one segment.
     * @param segmentId
     * @param force Force fetch from Strava API
     * @returns Segment Successful Response
     * @throws ApiError
     */
    public static getStravaSegmentStravaSegmentSegmentIdGet(
        segmentId: number,
        force: boolean = false,
    ): CancelablePromise<Segment> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/strava/segment/{segment_id}',
            path: {
                'segment_id': segmentId,
            },
            query: {
                'force': force,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Strava Activity Streams
     * Retrieve activity streams for the authenticated athlete, using cache unless forced.
     *
     * Requires JWT authentication via Bearer token.
     * @param activityId
     * @param force Force fetch from Strava API
     * @param keys Comma-separated stream keys
     * @returns Stream Successful Response
     * @throws ApiError
     */
    public static getStravaActivityStreamsStravaActivityActivityIdStreamsGet(
        activityId: number,
        force: boolean = false,
        keys?: (string | null),
    ): CancelablePromise<Record<string, Stream>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/strava/activity/{activity_id}/streams',
            path: {
                'activity_id': activityId,
            },
            query: {
                'force': force,
                'keys': keys,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Activities
     * Retrieve latest activities for the authenticated athlete, store in MongoDB, and return them.
     *
     * Requires JWT authentication via Bearer token.
     *
     * Args:
     * per_page (int): Number of activities to fetch per page (max 200).
     * start_key (int): Page key to start fetching from.
     * force (bool): Refresh gear summaries from Strava before returning the first page.
     * Returns:
     * PaginatedActivitiesSchema: Paginated list of activity records.
     * Raises:
     * HTTPException: If no credentials found or fetch fails.
     * @param perPage Number of activities per page
     * @param updatedSince Optional epoch seconds; return activities updated after this timestamp
     * @param startKey Starting page key for pagination (JSON-encoded)
     * @param force Refresh gear summaries for the first page from Strava; use per_page=200 for one maximum-sized Strava page
     * @returns PaginatedActivities Successful Response
     * @throws ApiError
     */
    public static getActivitiesStravaActivitiesGet(
        perPage: number = 100,
        updatedSince?: (number | null),
        startKey?: (string | null),
        force: boolean = false,
    ): CancelablePromise<PaginatedActivities> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/strava/activities',
            query: {
                'per_page': perPage,
                'updated_since': updatedSince,
                'start_key': startKey,
                'force': force,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Queue Length
     * Get current queue length and status.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getQueueLengthStravaQueueGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/strava/queue',
        });
    }
    /**
     * Start Backfill
     * Create or return a durable newest-first missing-data backfill for the athlete.
     * @param requestBody
     * @returns BackfillRun Successful Response
     * @throws ApiError
     */
    public static startBackfillStravaBackfillsPost(
        requestBody?: (BackfillStart | null),
    ): CancelablePromise<BackfillRun> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/strava/backfills',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                409: `A reconciliation run is already active`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Start Reconciliation
     * Scan Strava summaries and durably refresh only activities whose source data changed.
     * @returns BackfillRun Successful Response
     * @throws ApiError
     */
    public static startReconciliationStravaReconciliationsPost(): CancelablePromise<BackfillRun> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/strava/reconciliations',
            errors: {
                409: `A missing-data backfill is already active`,
            },
        });
    }
    /**
     * Get Backfill
     * Return authenticated progress, phase, and rate-limit wait state for one backfill.
     * @param runId
     * @returns BackfillRun Successful Response
     * @throws ApiError
     */
    public static getBackfillStravaBackfillsRunIdGet(
        runId: string,
    ): CancelablePromise<BackfillRun> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/strava/backfills/{run_id}',
            path: {
                'run_id': runId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Resume Backfill
     * Resume a failed or canceled backfill from its last committed cursor.
     * @param runId
     * @returns BackfillRun Successful Response
     * @throws ApiError
     */
    public static resumeBackfillStravaBackfillsRunIdResumePost(
        runId: string,
    ): CancelablePromise<BackfillRun> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/strava/backfills/{run_id}/resume',
            path: {
                'run_id': runId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Cancel Backfill
     * Stop future scheduled work while keeping durable progress for a later resume.
     * @param runId
     * @returns BackfillRun Successful Response
     * @throws ApiError
     */
    public static cancelBackfillStravaBackfillsRunIdCancelPost(
        runId: string,
    ): CancelablePromise<BackfillRun> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/strava/backfills/{run_id}/cancel',
            path: {
                'run_id': runId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Enqueue Get All Activities
     * Deprecated compatibility route for starting a durable full backfill.
     *
     * It no longer creates a self-chaining SQS activity pagination task.
     * @param page Deprecated; durable backfills always begin at page 1
     * @returns BackfillRun Successful Response
     * @throws ApiError
     */
    public static enqueueGetAllActivitiesStravaFetchAllActivitiesGet(
        page: number = 1,
    ): CancelablePromise<BackfillRun> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/strava/fetchAllActivities',
            query: {
                '_page': page,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Enqueue Get All Activity Streams
     * Deprecated compatibility route for the durable activity/stream/segment backfill.
     *
     * Streams begin only after the activity phase completes.
     * @returns BackfillRun Successful Response
     * @throws ApiError
     */
    public static enqueueGetAllActivityStreamsStravaFetchAllStreamsGet(): CancelablePromise<BackfillRun> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/strava/fetchAllStreams',
        });
    }
    /**
     * Get Trails
     * Return trails near a lat/lng position, optionally filtered by tags.
     *
     * Uses geohash spatial indexing — queries the centre cell and its 8 neighbours.
     * @param lat Centre latitude for spatial query
     * @param lng Centre longitude for spatial query
     * @param tags Comma-separated tag filter (e.g. ski_lift)
     * @returns TrailSearchResult Successful Response
     * @throws ApiError
     */
    public static getTrailsStravaTrailsGet(
        lat: number,
        lng: number,
        tags?: (string | null),
    ): CancelablePromise<TrailSearchResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/strava/trails',
            query: {
                'lat': lat,
                'lng': lng,
                'tags': tags,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Trail By Id
     * Return a single trail definition by source trail id.
     *
     * Includes full reference geometry coordinates so the UI can overlay the
     * theoretical trail path on map hover.
     * @param trailId
     * @param source Optional source filter (e.g. openskimap)
     * @returns Trail Successful Response
     * @throws ApiError
     */
    public static getTrailByIdStravaTrailTrailIdGet(
        trailId: string,
        source?: (string | null),
    ): CancelablePromise<Trail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/strava/trail/{trail_id}',
            path: {
                'trail_id': trailId,
            },
            query: {
                'source': source,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Split Activity
     * Split an activity stream into segments using the requested strategy.
     *
     * Currently supported strategies: ``snow_sport``
     *
     * The split result is cached in S3 alongside the activity streams.
     * Pass ``force=true`` to recompute and overwrite the cache.
     * @param activityId
     * @param requestBody
     * @returns SplitResult Successful Response
     * @throws ApiError
     */
    public static splitActivityStravaActivityActivityIdSplitPost(
        activityId: number,
        requestBody: SplitRequest,
    ): CancelablePromise<SplitResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/strava/activity/{activity_id}/split',
            path: {
                'activity_id': activityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
